import { Component, OnDestroy } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Organisation } from 'src/app/models/organisation';
import { IdentityUsersService } from 'src/app/services/identityUsers.service';
import { ToastService } from 'src/app/services/toast.service';
import { AddUserModal, addUserModalOptions } from '../../../../modals/add-user/add-user.modal';
import { LoggingService } from 'src/app/services/logging.service';
import { UserOverviewModel } from './user-overview.model';
import { Subscription } from 'rxjs';
import { IdentityOrganisationApiClient } from 'src/app/services/api-clients/identity-organisation.api-client';
import { SettingsBreadCrumbService, BreadCrumbOptions } from '../../settings-breadcrumb.service';
import { IdsForSettingsService } from '../../ids-for-settings.service';
import { PKIUrls } from 'src/app/constants/pkiurls.constants';
import { AppComponent } from '../../../app/app.component';

@Component({
  templateUrl: './settings-organisation-users.page.html'
})
export class SettingsOrganisationUsersPage implements OnDestroy {

  selectedOrganisationId: string = "";

  organisation!: Organisation
  hover: boolean = false;
  remainingUsers: number = 0;
  filter: string = '';
  users: UserOverviewModel[] = [];
  remainingUsersBelowTreshold: boolean = false;
  supportUrl: string = PKIUrls.CreateSupportTicket;

  organisationIdSubscription: Subscription;

  constructor(private modalService: NgbModal,
    private toastService: ToastService,
    private organisationApiClient: IdentityOrganisationApiClient,
    private usersService: IdentityUsersService,
    private loggingService: LoggingService,
    private idsForSettingsService: IdsForSettingsService,
    private settingsBreadCrumbService: SettingsBreadCrumbService,
    public whiteLabelProvider: AppComponent) {

    this.supportUrl = this.whiteLabelProvider.support ? (this.whiteLabelProvider.supportUrl ?? PKIUrls.CreateSupportTicket) : PKIUrls.CreateSupportTicket;
    
    this.organisationIdSubscription = this.idsForSettingsService.selectedOrganisationId$.subscribe(organisationId => {
      this.selectedOrganisationId = organisationId;

      // setup specialised breadcrumb
      this.settingsBreadCrumbService.SetOrganisationCrumbs(BreadCrumbOptions.Organisation_Users(this.selectedOrganisationId));
      if (organisationId) {
        this.organisationApiClient.getOrganisation(organisationId).subscribe({
          next: (organisationData) => {
            this.organisation = organisationData;
            if (this.organisation && this.organisation?.organisation) {
              this.remainingUsers = this.organisation?.organisation?.maxUserCount - this.organisation?.users.length;
              this.reloadUsers();
            }
          }
        });
      }
    });
  }

  ngOnDestroy(): void {
    this.organisationIdSubscription.unsubscribe();
  }

  applyFilter(event: Event) {
    this.filter = (event.target as HTMLInputElement).value;
  }

  async reloadUsers() {
    this.getUsers().catch((error) => this.loggingService.logException(error));
  }

  private async getUsers() {
    (await this.usersService.getUsers(this.organisation?.organisation?.guid)).subscribe({
      next: (data: any) => {
        this.users = data.users;
        this.remainingUsers = this.organisation?.organisation?.maxUserCount - this.users.length;
      }
    });
    this.setRemainingUsersBelowTreshold(this.remainingUsers)
  }

  private setRemainingUsersBelowTreshold(remainingUsers: number)
  {
    this.remainingUsersBelowTreshold = remainingUsers < 1
  }

  addUser() {
    const modalRef = this.modalService.open(AddUserModal, addUserModalOptions);
    modalRef.componentInstance.organisationGuid = this.organisation?.organisation?.guid;
    modalRef.componentInstance.organisationName = this.organisation?.organisation?.name;
    modalRef.closed.subscribe({
      next: (saveSuccesfull) => {
        this.reloadUsers();
        if (saveSuccesfull) {
          this.toastService.showSaved();
        }
      }
    });
  }
}
